import { all } from "redux-saga/effects";
import { watchAuthAsync } from "./authSaga";
import { watchArtAsync } from "./artSaga";

export function* rootSaga() {
  yield all([watchAuthAsync(), watchArtAsync()]);
}
